import Form from '@utilities/form';
import addAlertMessage from '@utilities/errors/add-alert-message';
import ScrollTo from "@utilities/scroll-to";
import Events from '@utilities/events';
import contactConstraints from './contact-constraints';

const JS_HOOK_CONTACT_ALERT = '[js-hook-contact-alert]';
const JS_HOOK_VALIDATORS = '[js-hook-contact-form-validators]';
const JS_HOOK_ADD_PREFIX = '[js-hook-form-add-prefix]';
const JS_HOOK_FORM_FIELDS = '[js-hook-contact-form-fields]';

const HIDDEN_CLASS = 'u-hidden';

/**
 * Used to handle Contact requests from user
 *
 * @class ContactForm
 * @extends {Form}
 */
class ContactForm extends Form {
  constructor(element) {
    super(element);

    this.prefixedFields = [...this.form.querySelector(JS_HOOK_ADD_PREFIX)];
    this.messageSelector = JS_HOOK_CONTACT_ALERT;
    this.formFields = this.form.querySelector(JS_HOOK_FORM_FIELDS);
    this.successText = this.form.dataset.simpleSuccessMessage;
    this.prefix = this.form.dataset.formPrefix;

    // this.errorText = this.form.dataset.simpleErrorMessage;

    // Init constraints
    this.initConstraints();

    // Events: Submit & Change Events
    this.bindChangeEvents();
    this.bindSubmitEvents();
  }

  /**
   * Init constraints for form validation for validate.js
   */
  initConstraints() {
    this.constraints = contactConstraints;
  }

  getDefaultValidators() {
    const { validators } = this.element.querySelector(JS_HOOK_VALIDATORS).dataset;
    const parsedValidators = Form.parseDefaults(validators);
    return parsedValidators.data;
  }

  submitForm() {
    /**
     * webtolead SF form doesnt support CORS
     * so they suggest a hack; posting the form to a hidden iframe
     * sorry
     */
    this.prefixedFields.forEach(field => {
      if (field.value.indexOf(this.prefix) === -1) field.value = `${this.prefix} - ${field.value}`;
    });

    // Safari requires the input value to be set in HTML (while using the iframe hack)
    const formInputs = [...this.form.querySelectorAll('input, textarea')];
    formInputs.forEach((input) => {
      if (input.tagName?.toLowerCase() === 'textarea') {
        input.innerText = input.value;
      } else {
        input.setAttribute('value', input.value);
      }
    });

    this.form.setAttribute('target', 'contact-form-hack');
    this.form.submit();
    this.hideButtonLoaders();
    this.afterSubmitFormSuccess();
  }

  afterSubmitFormSuccess() {
    const variationAttribute = this.form.querySelector('#contact-subject');
    const request = variationAttribute ? variationAttribute.options[variationAttribute.selectedIndex].textContent.replace(/\n/g, '').trim() : null;

    Events.$trigger('gtm::push', {
      data: {
        event: 'contact_us',
        request
      }
    });

    addAlertMessage({ message: this.successText, hook: this.messageSelector, type: 'success' });
    this.formFields.classList.add(HIDDEN_CLASS);
    this.form.reset();

    ScrollTo.scrollTo(this.form, 350, 180);
  }

  // simpleAfterSubmitFormError() {
  //   addAlertMessage({ message: this.errorText, hook: this.messageSelector, type: 'error' });
  // }
}

export default ContactForm;
